import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    products: 'Products', deals: 'Deals', stores: 'Stores', giftCards: 'Gift Cards',
    login: 'Login', signUp: 'Sign Up', dashboard: 'Dashboard', myOrders: 'My Orders',
    profile: 'Profile', wishlist: 'Wishlist', logout: 'Logout',
    notificationSettings: 'Notification Settings', searchProducts: 'Search products...',
    empoweringLocalSellers: 'Empowering Local Farmers',
    heroTitle1: 'Farm Fresh,', heroHighlight: 'Delivered', heroTitle2: 'to Your Doorstep',
    heroSubtitle: 'Buy fresh vegetables, fruits, flowers, and spices directly from local farmers on FarmDirectly.',
    shopFarmFresh: 'Shop Farm Fresh', sellYourProduce: 'Sell Your Produce',
    tenKProducts: '10K+ Products', fiveHundredSellers: '500+ Sellers', rating48: '4.8 Rating',
    wideSelection: 'Wide Selection', wideSelectionDesc: 'Browse products from thousands of independent merchants.',
    trustedSellers: 'Trusted Sellers', trustedSellersDesc: 'All merchants are verified and reviewed by our community.',
    securePayments: 'Secure Payments', securePaymentsDesc: 'Pay safely with Stripe or Razorpay payment processing.',
    addToCart: 'Add to Cart', addedToCart: 'Added to cart!', outOfStock: 'Out of Stock',
    reviews: 'Reviews', description: 'Description', specifications: 'Specifications',
    questionsAndAnswers: 'Q&A', relatedProducts: 'Related Products',
    recentlyViewed: 'Recently Viewed', compareProducts: 'Compare Products',
    featuredProducts: 'Featured Products', trendingProducts: 'Trending Products', viewAll: 'View All',
    flashDeal: 'FLASH DEAL', endsIn: 'Ends in', upTo: 'UP TO', off: 'OFF',
    limitedTimeOnly: 'Limited time only', days: 'DAYS', hrs: 'HRS', min: 'MIN', sec: 'SEC',
    shoppingCart: 'Shopping Cart', orderSummary: 'Order Summary', subtotal: 'Subtotal',
    tax: 'Tax', shipping: 'Shipping', discount: 'Discount', total: 'Total',
    proceedToCheckout: 'Proceed to Checkout', continueShopping: 'Continue Shopping',
    couponCode: 'Coupon code', apply: 'Apply', emptyCart: 'Your cart is empty',
    yourCartEmpty: 'Your cart is empty', cartEmptyDesc: 'Start adding items to your cart.',
    readyToSell: 'Ready to Start Selling?',
    readyToSellDesc: 'Join FarmDirectly and reach thousands of customers today.',
    createYourStore: 'Create Your Store',
    footerDesc: 'Multi-Tenant E-Commerce Platform empowering merchants to build and grow their online stores.',
    shop: 'Shop', allProducts: 'All Products', sell: 'Sell',
    becomeSeller: 'Sell Your Produce', sellerDashboard: 'Seller Dashboard',
    support: 'Support', helpCenter: 'Help Center', contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy', termsOfService: 'Terms of Service',
    aboutUs: 'About Us', faqShort: 'FAQ',
    newsletter: 'Newsletter', newsletterDesc: 'Get updates on new products, deals, and more.',
    subscribe: 'Subscribe', yourEmail: 'Your email', allRightsReserved: 'All rights reserved.',
    loading: 'Loading...', noResults: 'No results found', viewMore: 'View More',
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', create: 'Create',
    noProductsYet: 'No products available yet. Be the first seller!', startSelling: 'Start Selling',
    loyaltyPoints: 'Loyalty Points', pointsBalance: 'Points Balance',
    earnedPoints: 'You earned {points} points!', redeemPoints: 'Redeem Points',
    allProductsTitle: 'All Products', search: 'Search', newestFirst: 'Newest First',
    priceLowHigh: 'Price: Low to High', priceHighLow: 'Price: High to Low',
    topRated: 'Top Rated', minPrice: 'Min $', maxPrice: 'Max $', noProductsFound: 'No products found',
    browseStores: 'Browse Stores', searchStores: 'Search stores...',
    xProducts: '{count} products', noStoresFound: 'No stores found',
    comingSoon: 'Coming Soon', upcoming: 'Upcoming', offLabel: 'off',
    productsLabel: 'products', startsLabel: 'Starts', noFlashDeals: 'No flash deals right now',
    giftCardsTitle: 'Gift Cards & Store Credit', buyGiftCard: 'Buy Gift Card',
    redeemCode: 'Redeem Code', myBalance: 'My Balance', purchaseGiftCard: 'Purchase a Gift Card',
    recipientName: 'Recipient Name (optional)', recipientEmail: 'Recipient Email (optional)',
    personalMessage: 'Personal Message (optional)', purchaseButton: 'Purchase ${amount} Gift Card',
    yourPurchasedCards: 'Your Purchased Cards',
    signInTofarmdirectly: 'Sign In to FarmDirectly', chooseRole: 'Choose a role to Sign In.',
    dontHaveAccount: "Don't have an account?", createOne: 'Create one', signUpDot: 'Sign Up.',
    customerSignIn: 'Customer Sign In', merchantSignIn: 'Merchant Sign In', adminSignIn: 'Admin Sign In',
    shopperAndAffiliate: 'Shopper & Affiliate Partners',
    emailAddress: 'Email Address', password: 'Password', forgotPassword: 'Forgot Password?',
    signIn: 'Sign In', signingIn: 'Signing in...', welcomeBack: 'Welcome Back',
    signInSubtext: 'Sign in to access your orders, wishlist, loyalty points, and personalized recommendations.',
    sellerCentral: 'Seller Central',
    sellerCentralDesc: 'Manage your store, products, and orders. Reach millions of customers on FarmDirectly.',
    merchantOrTeam: 'Are you a merchant or team member?', dontHaveStore: "Don't have a store?",
    backToAllRoles: '← Back to all roles',
    customerPortal: 'Customer Portal', merchantPortal: 'Merchant Portal', operationsPortal: 'Operations Portal',
    rolesAvailable: '{count} roles available',
    customer: 'CUSTOMER', shopper: 'Shopper',
    customerDesc: 'Browse products, add to cart, checkout, track orders, write reviews, and earn loyalty points.',
    affiliatePartner: 'AFFILIATE PARTNER', referralPartner: 'Referral Partner',
    affiliateDesc: 'Share referral links, track commissions on referred sales, and grow your earnings.',
    merchantLogin: 'Farmer Login', operationsLogin: 'Operations Login', viewAllRoles: 'View all roles',
    operationsSignIn: 'Operations Sign In', operationsHub: 'Operations Hub',
    operationsHubDesc: 'The internal command center for FarmDirectly.',
    opsAccountsCreated: 'Operations accounts are created by your administrator.',
    opsAccountsCreatedFull: 'Operations accounts are created by your Super Admin. Contact your organization administrator for access.',
    joinfarmdirectly: 'Join FarmDirectly',
    chooseRoleSignUp: 'Choose a role to Sign Up.',
    signUpAs: 'SIGN UP AS',
    lookingForOpsRole: 'Looking for an operations role? (Support, Delivery, Finance, etc.)',
    newBadge: 'NEW',
    createAccount: 'Create Account:',
    creatingAccount: 'Creating Account...',
    chooseDifferentRole: 'Choose a different role',
    multiVendorMarketplace: 'Multi-Vendor Marketplace',
    cart: 'Cart', points: 'Points', orders: 'Orders', analytics: 'Analytics', coupons: 'Coupons',
    myWishlist: 'My Wishlist', wishlistEmpty: 'Your wishlist is empty',
    wishlistEmptyDesc: 'Browse products and click the heart icon to save them here.',
    browseProducts: 'Browse Products',
    allOrders: 'All Orders', noOrdersYet: 'No orders yet', viewMyOrders: 'View My Orders',
    myProfile: 'My Profile',
    forgotPasswordTitle: 'Forgot Password', resetPassword: 'Reset Password', sendResetLink: 'Send Reset Link',
    createAccountTitle: 'Create Your Account', firstName: 'First Name', lastName: 'Last Name',
    confirmPassword: 'Confirm Password', alreadyHaveAccount: 'Already have an account?', signInLink: 'Sign In',
    loginHistory: 'Login History', activeSessions: 'Active Sessions', securityAlerts: 'Security Alerts',
    // Roles
    roleMerchant: 'MERCHANT', roleMerchantSub: 'Store Owner', roleMerchantDesc: 'Manage your store, list products, process orders, run promotions, and view analytics.',
    roleMerchantStaff: 'MERCHANT STAFF', roleMerchantStaffSub: 'Store Team Member', roleMerchantStaffDesc: 'Help manage products, orders, and store operations with permissions set by the store owner.',
    roleAdmin: 'ADMIN', roleAdminSub: 'Platform Administrator', roleAdminDesc: 'Manage users, orders, stores, and platform-wide revenue analytics.',
    roleSupport: 'SUPPORT AGENT', roleSupportSub: 'Customer Support', roleSupportDesc: 'Handle customer inquiries, process refunds, answer Q&A, and moderate reviews.',
    roleDelivery: 'DELIVERY PARTNER', roleDeliverySub: 'Logistics', roleDeliveryDesc: 'View assigned orders, update delivery status, and confirm deliveries.',
    roleWarehouse: 'WAREHOUSE', roleWarehouseSub: 'Inventory Manager', roleWarehouseDesc: 'Monitor stock levels, update quantities, and manage warehouse operations.',
    roleFinance: 'FINANCE', roleFinanceSub: 'Accountant', roleFinanceDesc: 'Access revenue reports, tax summaries, merchant payouts, and transactions.',
    roleModerator: 'MODERATOR', roleModeratorSub: 'Content Review', roleModeratorDesc: 'Approve products, moderate reviews and Q&A, maintain content quality.',
    roleReturns: 'RETURNS MANAGER', roleReturnsSub: 'Returns Processing', roleReturnsDesc: 'Handle return requests, inspect items, process refunds and restocking.',
    roleMarketing: 'MARKETING', roleMarketingSub: 'Campaign Manager', roleMarketingDesc: 'Create banners, manage flash sales, feature products, and run promotions.',
    roleCatalog: 'CATALOG MANAGER', roleCatalogSub: 'SEO & Taxonomy', roleCatalogDesc: 'Manage categories, product metadata, slugs, and listing quality.',
    roleVendor: 'VENDOR ONBOARDING', roleVendorSub: 'Merchant Review', roleVendorDesc: 'Review new merchant applications, approve stores, guide setup.',
    roleAdManager: 'AD MANAGER', roleAdManagerSub: 'Sponsored Listings', roleAdManagerDesc: 'Manage ad campaigns, approve sponsored products, track ad performance.',
    roleCommunity: 'COMMUNITY', roleCommunitySub: 'Community Lead', roleCommunityDesc: 'Monitor community health, top reviewers, and engagement metrics.',
    roleDispute: 'DISPUTE ARBITRATOR', roleDisputeSub: 'Conflict Resolution', roleDisputeDesc: 'Resolve buyer-seller disputes, review evidence, issue rulings.',
    roleQA: 'QA TESTER', roleQASub: 'Quality Assurance', roleQADesc: 'Audit product listings for quality issues — missing images, descriptions, pricing.',
    roleRegional: 'REGIONAL MANAGER', roleRegionalSub: 'Regional Operations', roleRegionalDesc: 'Oversee regional logistics, delivery partner performance, and order routing.',
    roleAPI: 'API PARTNER', roleAPISub: 'Developer', roleAPIDesc: 'Manage API keys, monitor usage, configure webhooks and integrations.',
    // Checkout Page
    checkout: 'Checkout', orderItems: 'Order Items',
    billingAddress: 'Billing Address', streetAddress: 'Street Address', apartment: 'Apartment / Suite',
    city: 'City', state: 'State', zipCode: 'ZIP Code', country: 'Country', phone: 'Phone',
    orderNotes: 'Order Notes (optional)', paymentMethod: 'Payment Method',
    creditDebitCard: 'Credit / Debit Card', paySecurelyStripe: 'Pay securely with Stripe',
    upiCardsNetbanking: 'UPI, Cards, Netbanking, Wallets', cashOnDelivery: 'Cash on Delivery',
    payOnDelivery: 'Pay when you receive your order',
    free: 'FREE', placeOrder: 'Place Order', placingOrder: 'Placing Order...',
    fullName: 'Full Name', qty: 'Qty',
    // Order Detail
    backToOrders: 'Back to Orders', orderNotFound: 'Order not found',
    paymentSummary: 'Payment Summary', carrier: 'Carrier', trackingNumber: 'Tracking #',
    items: 'Items', method: 'Method',
    // Payment Page
    cardDetails: 'Card Details', completePayment: 'Complete Payment',
    paymentSuccessful: 'Payment Successful!',
    processingPayment: 'Processing Payment...',
    // Account Security
    mfa: 'Multi-Factor Authentication', enable: 'Enable', disable: 'Disable', verify: 'Verify',
    revokeAll: 'Revoke All',
    noLoginHistory: 'No login history recorded yet.', noActiveSessions: 'No active sessions.',
    noSecurityAlerts: 'No security alerts. Your account looks safe!',
    date: 'Date', device: 'Device', browserOs: 'Browser/OS', ip: 'IP', status: 'Status',
    // Store Detail
    storeInfo: 'Store Info', storeNotFound: 'Store not found',
    noStoreProducts: 'This store has no products yet.', followUs: 'Follow Us',
    // Compare Products
    addMoreProducts: 'Add more products to compare',
    noImage: 'No Image', stock: 'Stock', available: 'available',
    rating: 'Rating', price: 'Price', category: 'Category',
    // Notification Preferences
    notificationPrefs: 'Notification Preferences', loadingPrefs: 'Loading preferences...',
    emailNotifications: 'Email Notifications', pushNotifications: 'Push Notifications',
    orderUpdates: 'Order Updates', promotions: 'Promotions', priceAlerts: 'Price Alerts',
    savePreferences: 'Save Preferences', saving: 'Saving...',
    // Reset Password
    resetPasswordTitle: 'Reset Password', newPassword: 'New Password',
    resetPasswordBtn: 'Reset Password', resetting: 'Resetting...',
    // Verify Email
    verifyEmail: 'Verify Email', verifying: 'Verifying your email...',
    emailVerified: 'Email verified successfully!', verificationFailed: 'Verification failed.',
    // Register (legacy)
    register: 'Register', createYourAccount: 'Create your account',
    // Cancel & Return
    cancelOrder: 'Cancel Order', requestReturn: 'Request Return',
    cancelOrderConfirm: 'Are you sure you want to cancel this order?',
    cancelReasonPlaceholder: 'Reason for cancellation (optional)',
    confirmCancel: 'Yes, Cancel Order', cancelling: 'Cancelling...',
    orderCancelledSuccess: 'Order cancelled successfully',
    returnConfirm: 'Submit a return request for this order. Returns are accepted within 7 days of delivery.',
    returnReasonPlaceholder: 'Why are you returning this order? (required)',
    submitReturn: 'Submit Return Request', submitting: 'Submitting...',
    returnRequestSubmitted: 'Return request submitted successfully',
    pleaseProvideReason: 'Please provide a reason for the return',
  },
  ta: {
    products: 'பொருட்கள்', deals: 'சலுகைகள்', stores: 'கடைகள்', giftCards: 'பரிசு அட்டைகள்',
    login: 'உள்நுழைக', signUp: 'பதிவு செய்க', dashboard: 'டாஷ்போர்டு', myOrders: 'எனது ஆர்டர்கள்',
    profile: 'சுயவிவரம்', wishlist: 'விருப்பப்பட்டியல்', logout: 'வெளியேறு',
    notificationSettings: 'அறிவிப்பு அமைப்புகள்', searchProducts: 'பொருட்களைத் தேடுங்கள்...',
    empoweringLocalSellers: 'உள்ளூர் விவசாயிகளை மேம்படுத்துதல்',
    heroTitle1: 'பண்ணையிலிருந்து', heroHighlight: 'நேரடியாக', heroTitle2: 'உங்கள் வீட்டிற்கு',
    heroSubtitle: 'உள்ளூர் விவசாயிகளிடமிருந்து நேரடியாக காய்கறிகள், பழங்கள், பூக்கள் மற்றும் மசாலாப் பொருட்களை வாங்குங்கள்.',
    shopFarmFresh: 'ஷாப்பிங் தொடங்கு', sellYourProduce: 'விற்பனையாளர் ஆகுங்கள்',
    tenKProducts: '10,000+ பொருட்கள்', fiveHundredSellers: '500+ விற்பனையாளர்கள்', rating48: '4.8 மதிப்பீடு',
    wideSelection: 'பரந்த தேர்வு', wideSelectionDesc: 'ஆயிரக்கணக்கான சுயாதீன வணிகர்களிடமிருந்து பொருட்களை உலாவுங்கள்.',
    trustedSellers: 'நம்பகமான விற்பனையாளர்கள்', trustedSellersDesc: 'அனைத்து வணிகர்களும் எங்கள் சமூகத்தால் சரிபார்க்கப்பட்டவர்கள்.',
    securePayments: 'பாதுகாப்பான கொடுப்பனவுகள்', securePaymentsDesc: 'Stripe அல்லது Razorpay மூலம் பாதுகாப்பாக செலுத்துங்கள்.',
    addToCart: 'கூடையில் சேர்', addedToCart: 'கூடையில் சேர்க்கப்பட்டது!', outOfStock: 'கையிருப்பில் இல்லை',
    reviews: 'மதிப்பாய்வுகள்', description: 'விளக்கம்', specifications: 'விவரக்குறிப்புகள்',
    questionsAndAnswers: 'கே & ஏ', relatedProducts: 'தொடர்புடைய பொருட்கள்',
    recentlyViewed: 'சமீபத்தில் பார்த்தவை', compareProducts: 'ஒப்பிடு',
    featuredProducts: 'சிறப்பு பொருட்கள்', trendingProducts: 'பிரபலமான பொருட்கள்', viewAll: 'அனைத்தும் பார்',
    flashDeal: 'ஃப்ளாஷ் சலுகை', endsIn: 'முடிவடையும்', upTo: 'வரை', off: 'தள்ளுபடி',
    limitedTimeOnly: 'குறிப்பிட்ட நேரம் மட்டும்', days: 'நாட்கள்', hrs: 'மணி', min: 'நிமி', sec: 'வினா',
    shoppingCart: 'ஷாப்பிங் கூடை', orderSummary: 'ஆர்டர் சுருக்கம்', subtotal: 'உட்கூட்டு',
    tax: 'வரி', shipping: 'அனுப்புதல்', discount: 'தள்ளுபடி', total: 'மொத்தம்',
    proceedToCheckout: 'செக்அவுட் செல்ல', continueShopping: 'தொடர்ந்து வாங்கவும்',
    couponCode: 'கூப்பன் குறியீடு', apply: 'பொருத்து', emptyCart: 'உங்கள் கூடை காலியாக உள்ளது',
    yourCartEmpty: 'உங்கள் கூடை காலியாக உள்ளது', cartEmptyDesc: 'பொருட்களை கூடையில் சேர்க்கத் தொடங்குங்கள்.',
    readyToSell: 'விற்பனை தொடங்க தயாரா?',
    readyToSellDesc: 'FarmDirectly-ல் சேர்ந்து ஆயிரக்கணக்கான வாடிக்கையாளர்களை அடையுங்கள்.',
    createYourStore: 'உங்கள் கடையை உருவாக்குங்கள்',
    footerDesc: 'வணிகர்களை மேம்படுத்தும் பல-குத்தகை இ-காமர்ஸ் தளம்.',
    shop: 'கடை', allProducts: 'அனைத்து பொருட்கள்', sell: 'விற்க',
    becomeSeller: 'விற்பனையாளர் ஆகுங்கள்', sellerDashboard: 'விற்பனையாளர் டாஷ்போர்டு',
    support: 'உதவி', helpCenter: 'உதவி மையம்', contactUs: 'தொடர்பு கொள்ளுங்கள்',
    privacyPolicy: 'தனியுரிமை கொள்கை', termsOfService: 'சேவை விதிமுறைகள்',
    aboutUs: 'எங்களைப் பற்றி', faqShort: 'அடிக்கடி கேள்விகள்',
    newsletter: 'செய்திமடல்', newsletterDesc: 'புதிய பொருட்கள், சலுகைகள் பற்றிய புதுப்பிப்புகளைப் பெறுங்கள்.',
    subscribe: 'குழுசேர்', yourEmail: 'உங்கள் மின்னஞ்சல்', allRightsReserved: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
    loading: 'ஏற்றுகிறது...', noResults: 'முடிவுகள் இல்லை', viewMore: 'மேலும் பார்',
    save: 'சேமி', cancel: 'ரத்து', delete: 'நீக்கு', edit: 'திருத்து', create: 'உருவாக்கு',
    noProductsYet: 'இன்னும் பொருட்கள் இல்லை. முதல் விற்பனையாளர் ஆகுங்கள்!', startSelling: 'விற்பனை தொடங்கு',
    loyaltyPoints: 'விசுவாச புள்ளிகள்', pointsBalance: 'புள்ளிகள் இருப்பு',
    earnedPoints: 'நீங்கள் {points} புள்ளிகள் பெற்றீர்கள்!', redeemPoints: 'புள்ளிகளை பயன்படுத்து',
    allProductsTitle: 'அனைத்து பொருட்கள்', search: 'தேடு', newestFirst: 'புதியவை முதலில்',
    priceLowHigh: 'விலை: குறைவு → அதிகம்', priceHighLow: 'விலை: அதிகம் → குறைவு',
    topRated: 'மிகவும் மதிப்பிடப்பட்ட', minPrice: 'குறைந்தபட்ச ₹', maxPrice: 'அதிகபட்ச ₹',
    noProductsFound: 'பொருட்கள் இல்லை',
    browseStores: 'கடைகளை உலாவு', searchStores: 'கடைகளைத் தேடுங்கள்...',
    xProducts: '{count} பொருட்கள்', noStoresFound: 'கடைகள் இல்லை',
    comingSoon: 'விரைவில் வருகிறது', upcoming: 'வரவிருக்கும்', offLabel: 'தள்ளுபடி',
    productsLabel: 'பொருட்கள்', startsLabel: 'தொடங்கும்', noFlashDeals: 'தற்போது ஃப்ளாஷ் சலுகைகள் இல்லை',
    giftCardsTitle: 'பரிசு அட்டைகள் & கடை கிரெடிட்', buyGiftCard: 'பரிசு அட்டை வாங்கு',
    redeemCode: 'குறியீட்டை பயன்படுத்து', myBalance: 'எனது இருப்பு',
    purchaseGiftCard: 'பரிசு அட்டை வாங்குங்கள்',
    recipientName: 'பெறுநர் பெயர் (விரும்பினால்)', recipientEmail: 'பெறுநர் மின்னஞ்சல் (விரும்பினால்)',
    personalMessage: 'தனிப்பட்ட செய்தி (விரும்பினால்)', purchaseButton: '${amount} பரிசு அட்டை வாங்கு',
    yourPurchasedCards: 'நீங்கள் வாங்கிய அட்டைகள்',
    signInTofarmdirectly: 'FarmDirectly-ல் உள்நுழையுங்கள்', chooseRole: 'உள்நுழைய ஒரு பங்கை தேர்வு செய்யுங்கள்.',
    dontHaveAccount: 'கணக்கு இல்லையா?', createOne: 'ஒன்றை உருவாக்கு', signUpDot: 'பதிவு செய்யுங்கள்.',
    customerSignIn: 'வாடிக்கையாளர் உள்நுழைவு', merchantSignIn: 'வணிகர் உள்நுழைவு', adminSignIn: 'நிர்வாகி உள்நுழைவு',
    shopperAndAffiliate: 'வாடிக்கையாளர் & இணைப்பு பங்காளர்கள்',
    emailAddress: 'மின்னஞ்சல் முகவரி', password: 'கடவுச்சொல்', forgotPassword: 'கடவுச்சொல் மறந்துவிட்டதா?',
    signIn: 'உள்நுழைக', signingIn: 'உள்நுழைகிறது...', welcomeBack: 'மீண்டும் வருக',
    signInSubtext: 'உங்கள் ஆர்டர்கள், விருப்பப்பட்டியல், விசுவாச புள்ளிகள் மற்றும் பரிந்துரைகளை அணுக உள்நுழையுங்கள்.',
    sellerCentral: 'விற்பனையாளர் மையம்', sellerCentralDesc: 'உங்கள் கடை, பொருட்கள் மற்றும் ஆர்டர்களை நிர்வகிக்கவும்.',
    merchantOrTeam: 'நீங்கள் வணிகர் அல்லது குழு உறுப்பினரா?', dontHaveStore: 'கடை இல்லையா?',
    backToAllRoles: '← அனைத்து பங்குகளுக்கும் திரும்பு',
    customerPortal: 'வாடிக்கையாளர் போர்டல்', merchantPortal: 'வணிகர் போர்டல்', operationsPortal: 'செயல்பாட்டு போர்டல்',
    rolesAvailable: '{count} பங்குகள் கிடைக்கின்றன',
    customer: 'வாடிக்கையாளர்', shopper: 'வாங்குபவர்',
    customerDesc: 'பொருட்களை உலாவுங்கள், கூடையில் சேருங்கள், ஆர்டர் செய்யுங்கள், மதிப்புரைகள் எழுதுங்கள்.',
    affiliatePartner: 'இணைப்பு பங்காளர்', referralPartner: 'பரிந்துரை பங்காளர்',
    affiliateDesc: 'பரிந்துரை இணைப்புகளை பகிர்ந்து, கமிஷன்களை கண்காணிக்கவும்.',
    merchantLogin: 'வணிகர் உள்நுழைவு', operationsLogin: 'செயல்பாட்டு உள்நுழைவு',
    viewAllRoles: 'அனைத்து பங்குகளையும் காண',
    operationsSignIn: 'செயல்பாட்டு உள்நுழைவு', operationsHub: 'செயல்பாட்டு மையம்',
    operationsHubDesc: 'FarmDirectly-ன் உள்ளக கட்டுப்பாட்டு மையம்.',
    opsAccountsCreated: 'செயல்பாட்டு கணக்குகள் உங்கள் நிர்வாகியால் உருவாக்கப்படுகின்றன.',
    opsAccountsCreatedFull: 'செயல்பாட்டு கணக்குகள் உங்கள் சூப்பர் நிர்வாகியால் உருவாக்கப்படுகின்றன.',
    joinfarmdirectly: 'FarmDirectly-ல் இணையுங்கள்',
    chooseRoleSignUp: 'பதிவு செய்ய ஒரு பங்கை தேர்வு செய்யுங்கள்.',
    signUpAs: 'பதிவு செய்க:',
    lookingForOpsRole: 'செயல்பாட்டு பங்கு தேடுகிறீர்களா? (உதவி, டெலிவரி, நிதி, போன்றவை)',
    newBadge: 'புதிது',
    createAccount: 'கணக்கை உருவாக்குக:',
    creatingAccount: 'கணக்கு உருவாக்கப்படுகிறது...',
    chooseDifferentRole: 'வேறு பங்கை தேர்வு செய்க',
    multiVendorMarketplace: 'பல-விற்பனையாளர் சந்தை',
    cart: 'கூடை', points: 'புள்ளிகள்', orders: 'ஆர்டர்கள்', analytics: 'பகுப்பாய்வு', coupons: 'கூப்பன்கள்',
    myWishlist: 'எனது விருப்பப்பட்டியல்', wishlistEmpty: 'உங்கள் விருப்பப்பட்டியல் காலியாக உள்ளது',
    wishlistEmptyDesc: 'பொருட்களை உலாவி, இதயக் குறியைக் கிளிக் செய்து இங்கே சேமியுங்கள்.',
    browseProducts: 'பொருட்களை உலாவு',
    allOrders: 'அனைத்து ஆர்டர்கள்', noOrdersYet: 'இன்னும் ஆர்டர்கள் இல்லை',
    viewMyOrders: 'எனது ஆர்டர்களைக் காண', myProfile: 'எனது சுயவிவரம்',
    forgotPasswordTitle: 'கடவுச்சொல் மறந்துவிட்டதா', resetPassword: 'கடவுச்சொல்லை மீட்டமை',
    sendResetLink: 'மீட்டமைப்பு இணைப்பை அனுப்பு',
    createAccountTitle: 'உங்கள் கணக்கை உருவாக்குங்கள்', firstName: 'முதல் பெயர்', lastName: 'கடைசி பெயர்',
    confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து', alreadyHaveAccount: 'ஏற்கனவே கணக்கு உள்ளதா?', signInLink: 'உள்நுழைக',
    loginHistory: 'உள்நுழைவு வரலாறு', activeSessions: 'செயலில் உள்ள அமர்வுகள்', securityAlerts: 'பாதுகாப்பு எச்சரிக்கைகள்',
    // Roles
    roleMerchant: 'வணிகர்', roleMerchantSub: 'கடை உரிமையாளர்', roleMerchantDesc: 'உங்கள் கடையை நிர்வகிக்கவும், பொருட்களை பட்டியலிடவும், ஆர்டர்களை செயல்படுத்தவும்.',
    roleMerchantStaff: 'வணிக ஊழியர்', roleMerchantStaffSub: 'கடை குழு உறுப்பினர்', roleMerchantStaffDesc: 'கடை உரிமையாளர் அமைத்த அனுமதிகளுடன் பொருட்கள், ஆர்டர்களை நிர்வகிக்க உதவுங்கள்.',
    roleAdmin: 'நிர்வாகி', roleAdminSub: 'தளம் நிர்வாகி', roleAdminDesc: 'பயனர்கள், ஆர்டர்கள், கடைகள் மற்றும் வருவாய் பகுப்பாய்வை நிர்வகிக்கவும்.',
    roleSupport: 'உதவி முகவர்', roleSupportSub: 'வாடிக்கையாளர் உதவி', roleSupportDesc: 'வாடிக்கையாளர் கேள்விகளுக்கு பதிலளித்து, பணத்தைத் திருப்பி அளிக்கவும்.',
    roleDelivery: 'டெலிவரி பங்காளர்', roleDeliverySub: 'தளவாடம்', roleDeliveryDesc: 'ஒதுக்கப்பட்ட ஆர்டர்களைப் பார்க்கவும், டெலிவரி நிலையைப் புதுப்பிக்கவும்.',
    roleWarehouse: 'கிடங்கு', roleWarehouseSub: 'சரக்கு மேலாளர்', roleWarehouseDesc: 'கையிருப்பு நிலைகளை கண்காணிக்கவும், கிடங்கு செயல்பாடுகளை நிர்வகிக்கவும்.',
    roleFinance: 'நிதி', roleFinanceSub: 'கணக்காளர்', roleFinanceDesc: 'வருவாய் அறிக்கைகள், வரி சுருக்கங்கள், வணிகர் கொடுப்பனவுகளை அணுகவும்.',
    roleModerator: 'மதிப்பாய்வாளர்', roleModeratorSub: 'உள்ளடக்க ஆய்வு', roleModeratorDesc: 'பொருட்களை ஒப்புதல் அளிக்கவும், மதிப்புரைகளை நிர்வகிக்கவும்.',
    roleReturns: 'திரும்ப மேலாளர்', roleReturnsSub: 'திரும்புதல் செயலாக்கம்', roleReturnsDesc: 'திரும்ப கோரிக்கைகளை கையாளவும், பொருட்களை ஆய்வு செய்யவும்.',
    roleMarketing: 'சந்தைப்படுத்தல்', roleMarketingSub: 'பிரச்சார மேலாளர்', roleMarketingDesc: 'பேனர்களை உருவாக்கவும், விற்பனை நிகழ்வுகளை நிர்வகிக்கவும்.',
    roleCatalog: 'பட்டியல் மேலாளர்', roleCatalogSub: 'SEO & வகைப்பாடு', roleCatalogDesc: 'வகைகள், பொருள் தரவு, URL-கள் மற்றும் பட்டியல் தரத்தை நிர்வகிக்கவும்.',
    roleVendor: 'விற்பனையாளர் சேர்ப்பு', roleVendorSub: 'வணிகர் ஆய்வு', roleVendorDesc: 'புதிய வணிகர் விண்ணப்பங்களை ஆய்வு செய்யவும், கடைகளை ஒப்புதல் அளிக்கவும்.',
    roleAdManager: 'விளம்பர மேலாளர்', roleAdManagerSub: 'ஸ்பான்சர் பட்டியல்', roleAdManagerDesc: 'விளம்பர பிரச்சாரங்களை நிர்வகிக்கவும், விளம்பர செயல்திறனை கண்காணிக்கவும்.',
    roleCommunity: 'சமூகம்', roleCommunitySub: 'சமூக தலைவர்', roleCommunityDesc: 'சமூக ஆரோக்கியத்தை கண்காணிக்கவும், ஈடுபாட்டு அளவீடுகளை பார்க்கவும்.',
    roleDispute: 'தகராறு நடுவர்', roleDisputeSub: 'மோதல் தீர்வு', roleDisputeDesc: 'வாங்குபவர்-விற்பனையாளர் தகராறுகளை தீர்க்கவும், ஆதாரங்களை ஆய்வு செய்யவும்.',
    roleQA: 'QA சோதனையாளர்', roleQASub: 'தர உறுதி', roleQADesc: 'பொருள் பட்டியல்களை தரச் சிக்கல்களுக்காக ஆய்வு செய்யவும்.',
    roleRegional: 'பிராந்திய மேலாளர்', roleRegionalSub: 'பிராந்திய செயல்பாடுகள்', roleRegionalDesc: 'பிராந்திய தளவாடம், டெலிவரி செயல்திறனை மேற்பார்வையிடவும்.',
    roleAPI: 'API பங்காளர்', roleAPISub: 'டெவலப்பர்', roleAPIDesc: 'API விசைகளை நிர்வகிக்கவும், பயன்பாட்டை கண்காணிக்கவும்.',
    // Checkout
    checkout: 'பணம் செலுத்து', orderItems: 'ஆர்டர் பொருட்கள்',
    billingAddress: 'பில்லிங் முகவரி', streetAddress: 'தெரு முகவரி', apartment: 'அடுக்குமாடி / தொகுப்பு',
    city: 'நகரம்', state: 'மாநிலம்', zipCode: 'அஞ்சல் குறியீடு', country: 'நாடு', phone: 'தொலைபேசி',
    orderNotes: 'ஆர்டர் குறிப்புகள் (விரும்பினால்)', paymentMethod: 'பணம் செலுத்தும் முறை',
    creditDebitCard: 'கிரெடிட் / டெபிட் கார்டு', paySecurelyStripe: 'Stripe மூலம் பாதுகாப்பாக செலுத்துங்கள்',
    upiCardsNetbanking: 'UPI, கார்டுகள், நெட்பேங்கிங், வாலட்கள்', cashOnDelivery: 'டெலிவரியில் பணம்',
    payOnDelivery: 'ஆர்டர் பெறும்போது செலுத்துங்கள்',
    free: 'இலவசம்', placeOrder: 'ஆர்டர் செய்', placingOrder: 'ஆர்டர் செய்யப்படுகிறது...',
    fullName: 'முழு பெயர்', qty: 'எண்ணிக்கை',
    // Order Detail
    backToOrders: 'ஆர்டர்களுக்கு திரும்பு', orderNotFound: 'ஆர்டர் இல்லை',
    paymentSummary: 'பணம் செலுத்தல் சுருக்கம்', carrier: 'கேரியர்', trackingNumber: 'கண்காணிப்பு #',
    items: 'பொருட்கள்', method: 'முறை',
    // Payment
    cardDetails: 'கார்டு விவரங்கள்', completePayment: 'பணம் செலுத்தை முடிக்கவும்',
    paymentSuccessful: 'பணம் செலுத்துதல் வெற்றி!',
    processingPayment: 'பணம் செலுத்தப்படுகிறது...',
    // Account Security
    mfa: 'பல-காரணி அங்கீகாரம்', enable: 'இயக்கு', disable: 'முடக்கு', verify: 'சரிபார்',
    revokeAll: 'அனைத்தையும் ரத்து செய்',
    noLoginHistory: 'உள்நுழைவு வரலாறு இல்லை.', noActiveSessions: 'செயலில் உள்ள அமர்வுகள் இல்லை.',
    noSecurityAlerts: 'பாதுகாப்பு எச்சரிக்கைகள் இல்லை. உங்கள் கணக்கு பாதுகாப்பாக உள்ளது!',
    date: 'தேதி', device: 'சாதனம்', browserOs: 'உலாவி/OS', ip: 'IP', status: 'நிலை',
    // Store Detail
    storeInfo: 'கடை தகவல்', storeNotFound: 'கடை இல்லை',
    noStoreProducts: 'இந்த கடையில் இன்னும் பொருட்கள் இல்லை.', followUs: 'எங்களை பின்தொடருங்கள்',
    // Compare
    addMoreProducts: 'ஒப்பிட பொருட்களைச் சேர்க்கவும்',
    noImage: 'படம் இல்லை', stock: 'கையிருப்பு', available: 'கிடைக்கும்',
    rating: 'மதிப்பீடு', price: 'விலை', category: 'வகை',
    // Notification Prefs
    notificationPrefs: 'அறிவிப்பு விருப்பத்தேர்வுகள்', loadingPrefs: 'விருப்பத்தேர்வுகள் ஏற்றுகிறது...',
    emailNotifications: 'மின்னஞ்சல் அறிவிப்புகள்', pushNotifications: 'புஷ் அறிவிப்புகள்',
    orderUpdates: 'ஆர்டர் புதுப்பிப்புகள்', promotions: 'விளம்பரங்கள்', priceAlerts: 'விலை எச்சரிக்கைகள்',
    savePreferences: 'விருப்பத்தேர்வுகளை சேமி', saving: 'சேமிக்கிறது...',
    // Reset Password
    resetPasswordTitle: 'கடவுச்சொல்லை மீட்டமை', newPassword: 'புதிய கடவுச்சொல்',
    resetPasswordBtn: 'கடவுச்சொல்லை மீட்டமை', resetting: 'மீட்டமைக்கிறது...',
    // Verify Email
    verifyEmail: 'மின்னஞ்சலை சரிபார்', verifying: 'உங்கள் மின்னஞ்சலை சரிபார்க்கிறது...',
    emailVerified: 'மின்னஞ்சல் வெற்றிகரமாக சரிபார்க்கப்பட்டது!', verificationFailed: 'சரிபார்ப்பு தோல்வி.',
    // Register
    register: 'பதிவு', createYourAccount: 'உங்கள் கணக்கை உருவாக்குங்கள்',
    // Cancel & Return
    cancelOrder: 'ஆர்டரை ரத்து செய்', requestReturn: 'திரும்புதல் கோரிக்கை',
    cancelOrderConfirm: 'இந்த ஆர்டரை ரத்து செய்ய விரும்புகிறீர்களா?',
    cancelReasonPlaceholder: 'ரத்து செய்வதற்கான காரணம் (விரும்பினால்)',
    confirmCancel: 'ஆம், ரத்து செய்', cancelling: 'ரத்து செய்கிறது...',
    orderCancelledSuccess: 'ஆர்டர் வெற்றிகரமாக ரத்து செய்யப்பட்டது',
    returnConfirm: 'இந்த ஆர்டருக்கு திரும்புதல் கோரிக்கையை சமர்ப்பிக்கவும். டெலிவரிக்கு 7 நாட்களுக்குள் திரும்புதல் ஏற்கப்படும்.',
    returnReasonPlaceholder: 'இந்த ஆர்டரை ஏன் திரும்பப் பெறுகிறீர்கள்? (தேவை)',
    submitReturn: 'திரும்புதல் கோரிக்கையை சமர்ப்பி', submitting: 'சமர்ப்பிக்கிறது...',
    returnRequestSubmitted: 'திரும்புதல் கோரிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது',
    pleaseProvideReason: 'திரும்புதலுக்கான காரணத்தை வழங்கவும்',
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'ta', label: 'தமிழ்', flag: '🇮🇳' },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('farmdirectly_lang') || 'en'; } catch { return 'en'; }
  });

  const t = useCallback((key, replacements = {}) => {
    let text = translations[lang]?.[key] || translations.en[key] || key;
    Object.entries(replacements).forEach(([k, v]) => { text = text.replace(`{${k}}`, v); });
    return text;
  }, [lang]);

  const setLanguage = useCallback((code) => {
    setLang(code);
    try { localStorage.setItem('farmdirectly_lang', code); } catch {}
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
